import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import router from './router';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import '@fortawesome/fontawesome-free/css/all.min.css';

// Importar Bootstrap y BootstrapVue CSS
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

// Importar BootstrapVue
import { BootstrapVue3 } from 'bootstrap-vue-3';

// Importar sistema de autenticación
import { WidgetAuthPlugin } from './services/widgetAuth.js';

console.log("Entorno:")
console.log(import.meta.env.NODE_ENV)

const app = createApp(App);

// Instalar plugins
app.use(router);
app.use(BootstrapVue3);
app.use(WidgetAuthPlugin);

// Habilitar Vue Devtools solo en modo desarrollo
if (import.meta.env.NODE_ENV === 'development') {
  app.config.devtools = true; // Habilita las herramientas de desarrollo de Vue
}

app.mount('#app');